import ICharacter from '#/types/characters';

export const CharacterDetailsActionType = {
  CHARACTER_DETAILS_SET_CHARACTER_DETAILS:
    'character_details/set_character_details',
} as const;

export type TCharacterDetailsActions = {
  type: typeof CharacterDetailsActionType.CHARACTER_DETAILS_SET_CHARACTER_DETAILS;
  payload: ICharacter | undefined;
};
